<template>
  <d2-container>
    <template slot="header">
      <el-form
        :inline="true"
        :model="searchForm"
        ref="searchForm"
        size="mini"
        style="margin-bottom: -18px;"
      >
        <el-form-item
          label="姓名"
          prop="userName"
        >
          <el-input
            v-model="searchForm.userName"
            placeholder="姓名"
            style="width: 100px;"
          />
        </el-form-item>

        <el-form-item
          label="手机号码"
          prop="mobileNo"
        >
          <el-input
            v-model="searchForm.mobileNo"
            placeholder="手机号码"
            style="width: 120px;"
          />
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="handleSearchFormSubmit"
          >
            <d2-icon name="search" /> 查询
          </el-button>
        </el-form-item>

        <el-form-item>
          <el-button @click="handleSearchFormReset">
            <d2-icon name="refresh" /> 重置
          </el-button>
        </el-form-item>
      </el-form>
    </template>
    <el-button
      type="primary"
      size="mini"
      icon="el-icon-circle-plus"
      @click="add"
    >
      新增
    </el-button>
    <el-button
      v-if="multipleSelection.length>0"
      type="danger"
      size="mini"
      icon="el-icon-delete"
      @click="batchDel"
    >
      删除
    </el-button>
    <el-table
      :data="tableData"
      v-loading="loading"
      size="small"
      stripe
      highlight-current-row
      style="width: 100%;"
      @selection-change="handleSelectionChange"
      @sort-change="handleSortChange"
    >

      <el-table-column
        type="selection"
        width="55"
      >
      </el-table-column>
      <el-table-column
        label="姓名"
        prop="name"
        sortable="custom"
      >
        <template slot-scope="scope">
          {{scope.row.userName}}
        </template>
      </el-table-column>

      <el-table-column
        label="用户名"
        prop="trueName"
        sortable="custom"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          {{scope.row.userCode}}
        </template>
      </el-table-column>
      <el-table-column
              label="手机号码"
              prop="trueName"
              sortable="custom"
              :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          {{scope.row.mobileNo}}
        </template>
      </el-table-column>
      <el-table-column
        label="性别"
        prop="email"
        sortable="custom"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.sex=='0'">
            男
          </div>
          <div v-else-if="scope.row.sex=='1'">
            女
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="所属门店"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          {{scope.row.shop_name}}
        </template>
      </el-table-column>
      <el-table-column
              label="角色"
              :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.cashing=='1'">
            店长
          </div>
          <div v-else-if="scope.row.cashing=='2'">
            店员
          </div>
        </template>
      </el-table-column>
      <el-table-column
              label="状态"
              :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.disabled=='1'">
            正常
          </div>
          <div v-else-if="scope.row.disabled=='2'">
            禁用
          </div>
        </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        label="操作"
        align="center"
        width="280"
      >
        <template slot-scope="scope">

          <el-button type="primary" plain size="mini"    @click="openEditForm(scope.row)">编辑</el-button>
          <el-button type="primary" plain size="mini"    @click="openEditForm2(scope.row)">详情</el-button>
          <el-button type="primary" plain size="mini"    @click="reset(scope.row.userId)">重置密码</el-button>
        </template>
      </el-table-column>

    </el-table>
    <template slot="footer">
      <el-pagination
        :current-page="page.current"
        :page-size="page.size"
        :total="page.total"
        :page-sizes="[1,10,50,100, 200, 300, 400]"
        layout="total, sizes, prev, pager, next, jumper"
        style="margin: -10px;"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </template>
    <edit-form
      :user="user"
      v-model="editFormVisible"
      :accuseVisible="accuseVisible"
      @submit="getTableData"
    />
  </d2-container>
</template>
<script>
import * as userService from '@/api/sys/user'
import * as agentService from '@/api/sys/agent'
import editForm from './editForm'
import util from '@/libs/util.js'
export default {
  name: 'UserPage',
  components: { editForm },
  data () {
    return {
      searchForm: {
        name: '',
        email: ''
      },
      loading: false,
      tableData: [],
      accuseVisible: true,
      multipleSelection: [],
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      sort: {
        prop: '',
        order: ''
      },
      user: {},
      editFormVisible: false
    }
  },
  mounted () {
    console.log('is_agentid===' + this.is_agentid)
    this.getTableData()
  },
  methods: {
    getTableData () {
      let query = {
        pageIndex: this.page.current,
        pageSize: this.page.size,
        sortBy: this.sort.prop,
        descending: this.sort.order === 'descending',
        agentid: util.cookies.get('agentid'),
        filter: this.searchForm
      }
      userService.getUserStaffPagedList(query).then(data => {
        this.tableData = data.rows
        this.page.total = data.totalCount
      })
    },
    handleSearchFormSubmit () {
      this.getTableData()
    },
    handleSearchFormReset () {
      this.$refs.searchForm.resetFields()
    },
    handleSelectionChange (val) {
      this.multipleSelection = val
    },
    handleSortChange (val) {
      this.sort.prop = val.prop
      this.sort.order = val.order
      this.getTableData()
    },
    handleSizeChange (val) {
      this.page.size = val
      this.getTableData()
    },
    handleCurrentChange (val) {
      this.page.current = val
      this.getTableData()
    },
    openEditForm (user) {
      this.user = user
      this.editFormVisible = true
      this.accuseVisible = true
    },
    openEditForm2 (user) {
      this.user = user
      this.editFormVisible = true
      this.accuseVisible = false
    },
    add () {
      this.user = {}
      this.editFormVisible = true
    },
    batchDel () {
      this.$confirm('确认删除？', '确认信息', {
        distinguishCancelAndClose: true,
        confirmButtonText: '删除',
        cancelButtonText: '取消'
      }).then(() => {
        userService
          .delUsers({
            ids: JSON.stringify(this.multipleSelection.map(s => s.userId))
          })
          .then(() => {
            this.getTableData()
          })
      })
    },
    reset (userId) {
      let msg = '重置密码'
      this.$confirm('确定要重置该帐号的密码吗？！重置后的密码为123456', '确认信息', {
        distinguishCancelAndClose: true,
        confirmButtonText: msg,
        cancelButtonText: '取消'
      }).then(() => {
        agentService.resetAgent({ userId: userId }).then(() => {
          this.getTableData()
        })
      })
    },
    del (id) {
      this.$confirm('确认删除？', '确认信息', {
        distinguishCancelAndClose: true,
        confirmButtonText: '删除',
        cancelButtonText: '取消'
      }).then(() => {
        userService.delUser({ id: id }).then(() => {
          this.getTableData()
        })
      })
    }
  }
}
</script>
